import { CampaignPostsController } from './campaign-posts.controller'

function campaignPosts () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-posts/campaign-posts.html?$$REVISION$$',
    controller: CampaignPostsController
  }
}

export { campaignPosts }
